import React from "react";

export default () => (
  <>
    <h1 className="title">PAGE 404</h1>
    <p className="notification is-info">LOOOOOOOOOOOOOOOOOST !</p>
  </>
);
